export default class ListColHeight {
    constructor(classSelector: string) {
        if (document.body.classList.contains('hvd')) {
            return;
        }
        this.setHeight(classSelector);
        window.addEventListener('resize', () => this.setHeight(classSelector));
    }

    setHeight(classSelector: string) {
        document.querySelectorAll(classSelector).forEach((row: HTMLElement) => {
            if (row.offsetParent) {
                let rowHeight = 0;
                for (let colIndex = 0; colIndex < row.children.length; colIndex++) {
                    let col = <HTMLElement>row.children[colIndex];
                    col.style.height = '';
                    let colHeight = parseFloat(window.getComputedStyle(col).height);
                    if (colHeight > rowHeight) {
                        rowHeight = colHeight;
                    }
                }
                for (let colIndex = 0; colIndex < row.children.length; colIndex++) {
                    (<HTMLElement>row.children[colIndex]).style.height = rowHeight + 'px';
                }
            }
        });
    }
}
